import type {SchemeLogoProps} from '../../CreditCardSchemeLogo.tsx';

export function DinersLogo({className, color = '#FFFFFF'}: SchemeLogoProps) {
    return (
        <svg
            aria-label="Diners Club"
            className={className}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="18" cy="24" r="12" stroke={color} strokeWidth="2" fill="none" />
            <circle cx="30" cy="24" r="12" stroke={color} strokeWidth="2" fill="none" />
            <text
                x="24"
                y="42"
                textAnchor="middle"
                fill={color}
                fontSize="7"
                fontFamily="sans-serif"
                fontWeight="bold"
            >
                DINERS
            </text>
        </svg>
    );
}
